/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, Redirect, NavLink } from 'react-router-dom';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import BPLSReports from './transactions/containers/BPLSReports';
import FireSafetyReports from './transactions/containers/FireSafetyReports';
import AmnestyReports from './transactions/containers/AmnestyReports';

function BPLSReportsContainer({ match }) {
  const permissions = getJson('permissions');

  return (
    <>
      <div className="">
        <div className="pt-5 pl-5">
          <SideScrollingTab dragToScroll hideScrollButtons>
            <div className="report-module-nav mb-3">
              {Acl(permissions, ['VIEW BPLS REPORT PRE REGISTRATION']) && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/transactions`}
                >
                  Pre-Register
                </NavLink>
              )}
              {Acl(permissions, ['VIEW BPLS REPORT FIRE SAFETY']) && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/fire-safety`}
                >
                  Fire Safety
                </NavLink>
              )}
              {Acl(permissions, ['VIEW BPLS REPORT TAX AMNESTY']) && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/amnesty`}
                >
                  Amnesty
                </NavLink>
              )}
            </div>
          </SideScrollingTab>
        </div>
        <Switch>
          {Acl(permissions, ['VIEW BPLS REPORT PRE REGISTRATION']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/transactions`} />}
            />
          )}
          {Acl(permissions, ['VIEW BPLS REPORT PRE REGISTRATION']) && (
            <Route
              path={`${match.path}/transactions`}
              component={BPLSReports}
            />
          )}
          {Acl(permissions, ['VIEW BPLS REPORT FIRE SAFETY']) && (
            <Route
              path={`${match.path}/fire-safety`}
              component={FireSafetyReports}
            />
          )}
          {Acl(permissions, ['VIEW BPLS REPORT TAX AMNESTY']) && (
            <Route path={`${match.path}/amnesty`} component={AmnestyReports} />
          )}
        </Switch>
      </div>
    </>
  );
}

BPLSReportsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(BPLSReportsContainer);
